import { PresentBigWinActionHandler, type ReplayPlugin } from "@slot/client-engine";
import type { BigWinPresenter } from "./BigWinPresenter";

/** The big-win overlay on `present_big_win` (the server decides if and when). */
export function createBigWinPlugin(deps: { presenter: BigWinPresenter }): ReplayPlugin {
  return {
    name: "big-win",
    actionHandlers: [new PresentBigWinActionHandler((input) => deps.presenter.presentBigWin(input))],
  };
}
